import { render, staticRenderFns } from "./battle-stadium.vue?vue&type=template&id=6e786dd0&scoped=true&"
import script from "./battle-stadium.vue?vue&type=script&lang=js&"
export * from "./battle-stadium.vue?vue&type=script&lang=js&"
import style0 from "./battle-stadium.vue?vue&type=style&index=0&id=6e786dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e786dd0",
  null
  
)

export default component.exports